import { gql } from '@apollo/client';

export const mutation = gql`
  mutation RemoveSampleEvent(
    $sample_events_pk_columns: sample_events_pk_columns_input!
    $sample_events_set_input: sample_events_set_input!
  ) {
    update_sample_events_by_pk(pk_columns: $sample_events_pk_columns, _set: $sample_events_set_input) {
      id
    }
  }
`;

export function buildVariables({ id }) {
  return {
    sample_events_pk_columns: {
      id,
    },
    sample_events_set_input: {
      deletedAt: 'now()',
    },
  };
}
